import React from 'react'
import CreateGuide from "../components/CreateSiteGuide/CreateGuide";

class CreateSite extends React.Component
{
render() {
    return(
        <div>
                <div>
                    <CreateGuide/>
                </div>
        </div>
    );
}
}
export default CreateSite


// WEBPACK FOOTER //
// ./src/pages/CreateSite.js